const CancelLightGreyIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="24" viewBox="0 0 17 24" fill="none">
            <path d="M13.1824 17.488C12.9759 17.488 12.7696 17.4093 12.612 17.2517L3.73628 8.37665C3.42124 8.0618 3.42124 7.55112 3.73628 7.23626C4.05132 6.92125 4.56186 6.92125 4.8769 7.23626L13.7526 16.1113C14.0677 16.4262 14.0677 16.9368 13.7526 17.2517C13.5952 17.4093 13.3889 17.488 13.1824 17.488Z" fill="#B8B7BD" />
            <path d="M4.30667 17.4879C4.10019 17.4879 3.89388 17.4092 3.73628 17.2516C3.42124 16.9368 3.42124 16.4261 3.73628 16.1112L12.612 7.2362C12.9272 6.92118 13.4377 6.92135 13.7526 7.2362C14.0675 7.55106 14.0677 8.06174 13.7526 8.37659L4.8769 17.2516C4.71946 17.4092 4.51314 17.4879 4.30667 17.4879Z" fill="#B8B7BD" />
        </svg>
    )
}

export default CancelLightGreyIcon